<div class="shimmer-container" [class]="panelClass">
  <article [class.one-line]="line == 1" *ngFor="let shm of [].constructor(line)" >
      <div class='user'>
        <div class="line" *ngFor="let c of [].constructor(col)"></div>
      </div>
      <div class="shimmer"></div>
  </article>
</div>
